'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {String} type The type of request (see https://marmelab.com/admin-on-rest/RestClients.html)
 * @param {String} resource Name of the resource to fetch, e.g. 'posts'
 * @param {Object} params The REST request params, depending on the type
 * @returns {Object} apolloParams An object passed to either apolloClient.query or apolloClient.mutate
 */
exports.default = function (queries, type, resource, params) {
    var resourceQueries = queries[resource];

    if (!resourceQueries) {
        var knownResources = Object.keys(queries).map(function (key) {
            return '\r\n - ' + key;
        }).join('');
        throw new Error('Unable to find queries and/or mutations for the "' + resource + '" resource. Known resources are: ' + knownResources);
    }

    switch (type) {
        case _constants.GET_LIST:
            {
                return {
                    query: resourceQueries[_constants.GET_LIST],
                    variables: {
                        filter: JSON.stringify(params.filter),
                        page: params.pagination.page - 1,
                        perPage: params.pagination.perPage,
                        sortField: params.sort.field,
                        sortOrder: params.sort.order
                    }
                };
            }

        case _constants.GET_ONE:
            return {
                query: resourceQueries[_constants.GET_ONE],
                variables: {
                    id: params.id
                }
            };

        case _constants.GET_MANY:
            {
                var variables = {
                    filter: JSON.stringify({ ids: params.ids })
                };

                if (!resourceQueries[_constants.GET_MANY]) {
                    variables = (0, _extends3.default)({}, variables, {
                        perPage: 1000
                    });
                }

                return {
                    query: resourceQueries[_constants.GET_MANY] || resourceQueries[_constants.GET_LIST],
                    variables: variables
                };
            }

        case _constants.GET_MANY_REFERENCE:
            {
                var _variables = {
                    filter: JSON.stringify((0, _defineProperty3.default)({}, params.target, params.id))
                };

                if (!resourceQueries[_constants.GET_MANY_REFERENCE]) {
                    _variables = (0, _extends3.default)({}, _variables, {
                        perPage: 1000
                    });
                }

                return {
                    query: resourceQueries[_constants.GET_MANY_REFERENCE] || resourceQueries[_constants.GET_LIST],
                    variables: _variables
                };
            }

        case _constants.UPDATE:
            return {
                mutation: resourceQueries[_constants.UPDATE],
                variables: { data: JSON.stringify(params.data) }
            };

        case _constants.CREATE:
            return {
                mutation: resourceQueries[_constants.CREATE],
                variables: { data: JSON.stringify(params.data) }
            };

        case _constants.DELETE:
            return {
                mutation: resourceQueries[_constants.DELETE],
                variables: {
                    id: params.id
                }
            };

        default:
            throw new Error('Unsupported fetch action type ' + type);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/aor-simple-graphql-client/lib/buildApolloParams.js
// module id = 927
// module chunks = 0